<template>
  <div class="header">
    <div class="contant">
      <div class="logoUnit">
        <img src="../assets/img/cloudLogo.png" alt />
      </div>
      <div class="close" @click="close">退出</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
       
    }
  },
  methods:{
    close(){
      this.$router.push({
        path: "/customerLogin",
      });
    }
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 60px;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .contant {
    width: 90%;
    // min-width: 1000px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logoUnit {
      img {
        width: 168px;
        height: 26px;
      }
    }
    .close {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>